import { Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import LocationPicker from "../components/LocationPicker";
import { FilterComponent } from "../components/FilterComponents";
import * as locCon from "../LocalConstants"
import * as libCon from "../community-hats-js-library/Constants"
import { RefAllActionItemsWithParticipants } from "../hooks/DatasetHooks";
import { filterObjectByKeys, isNullOrUndefined } from "../community-hats-js-library/utils/generalFunctions";
import { LoadingActionItemsAndParticipants } from "../components/LoadingDatasets";
import { ActionItemTable } from "../components/Tables";
import { RefContextLanguage } from "../providers/LanguageProvider";



const { Title } = Typography;

function DashboardActionItems() {

  const i18n = RefContextLanguage()

  const [actionItemsStatus, actionItems] = RefAllActionItemsWithParticipants()

  const [actionItemsArray, setActionItemsArray] = useState(null)


  useEffect(() => {
    
    if(actionItemsStatus !== libCon.OK || isNullOrUndefined(actionItems))
      setActionItemsArray(null)
    else
    {
      
      let newActionItemsArray = Object.values(actionItems).filter(iss => iss[libCon.ATF_PARTICIPANT].length > 0)
      newActionItemsArray = newActionItemsArray.map(iss => {return({...iss,  ...filterObjectByKeys(iss[libCon.ATF_PARTICIPANT][0], [libCon.ATF_AREA, libCon.ATF_NAME, libCon.ATF_SEWA_ID, libCon.ATF_LAST_NAME]) })})
         
      setActionItemsArray(newActionItemsArray)

    }

  }, [actionItems, actionItemsStatus])
    

  return (
    <div className="mainContainer">
      <Title level={2}>{i18n.t('participantActionItems')}</Title>
      <Space direction="vertical" style={{ marginBottom: "10px" }}>
        <LocationPicker />
      </Space>

      <Space direction="vertical">
        <FilterComponent filterId={locCon.FILTER_TEXT_ACTION_ITEMS} />

        {
          actionItemsStatus !== libCon.OK || isNullOrUndefined(actionItemsArray)
          ? <LoadingActionItemsAndParticipants />
          : <ActionItemTable actionItemsArray={actionItemsArray}/>
        }
      </Space>

    </div>
  );
}

export default DashboardActionItems;
